import { useEffect } from 'react';
import { plataforma } from '@/platform';

/**
 * Re-executa `recarregar` toda vez que a plataforma sinaliza mudança de
 * status de sincronização — no desktop é o `sync:status-mudou` do main
 * process (push terminou, numeração terminou); no web é o WebSocket do
 * servidor avisando que a conta mudou em outro lugar. Isso
 * mantém as listas em sincronia automaticamente:
 *
 *   - Usuário salva offline → entidade gravada com `sync_pendente=true`
 *   - Lista mostra ⏳ Aguardando servidor
 *   - Servidor volta → push confirma → DB grava `sync_pendente=false`
 *   - Evento dispara → hook recarrega → badge some sozinho
 *
 * Idempotente: assinatura é registrada uma vez por mount e desfeita no
 * unmount via a função de unsubscribe devolvida pela plataforma.
 */
export function useSyncReload(recarregar: () => void | Promise<void>): void {
  useEffect(() => {
    const unsubscribe = plataforma.aoMudarStatus(() => {
      void recarregar();
    });
    return unsubscribe;
  }, [recarregar]);
}
